import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Block, { BlockHeader } from '../Block';
import { getString as s } from '../../lib/strings';
import Button from '../Button';

const EmailBlock = styled(Block)`
  border-top: none;
  padding-top: 0;
`;

const LoginError = (props) => {
  let title = '';
  let message = '';
  const buttonTxt = s('errors.button', 'Reload page');
  if (props.error === 'USER_NOT_FOUND') {
    title = s('login.unknown.title', 'Sorry!');
    message = s(
      'login.unknown.subtitle',
      'Unfortunately you have not subscribed to any permissions so cannot access the permission centre'
    );
  } else if (props.error === 'GATEWAY_EMAIL_SENDING') {
    title = s('errors.email.title', 'Sorry!');
    message = s(
      'errors.email.subtitle',
      'It looks like something went wrong. Please try again, or come back later'
    );
  } else if (props.error === 'EXPIRED') {
    title = s('login.expired.title', 'Sorry!');
    message = s(
      'login.expired.subtitle',
      'It looks like something went wrong. Please try again, or come back later'
    );
  } else {
    title = s('errors.api-error.title', 'Sorry!');
    message = s(
      'errors.api-error.subtitle',
      'It looks like something went wrong. Please try again, or come back later'
    );
  }
  return (
    <EmailBlock>
      <BlockHeader primary={title} secondary={message} />
      <Button>
        <a href="/login">{buttonTxt}</a>
      </Button>
    </EmailBlock>
  );
};

LoginError.propTypes = {
  error: PropTypes.string.isRequired
};

export default LoginError;
